export const mapAndMergeMetrics = (
  items: any[],
  fieldMap: Record<string, string>,
  mergeMap?: Record<string, string[]>,
) => {
  return items.map((item) => {
    const mapped: Record<string, any> = {};

    for (const [key, value] of Object.entries(item)) {
      if (fieldMap[key]) {
        mapped[fieldMap[key]] = value;
      } else {
        mapped[key] = value;
      }
    }

    if (mergeMap) {
      for (const [newKey, oldKeys] of Object.entries(mergeMap)) {
        mapped[newKey] = oldKeys.reduce((sum, oldKey) => {
          const mappedKey = fieldMap[oldKey] ?? oldKey;
          return sum + (mapped[mappedKey] ?? 0);
        }, 0);
      }
    }

    return mapped;
  });
};
